<div class="wrapper-body">
    <div class="page-header d-flex align-items-center">
        <h3>Set Availability</h3>
    </div>
    <form id="diagnoSetAvailabilityForm" required>
        <!-- <div class="custom-timeline"> -->
        <div class="card mt-3"  *ngIf="show">
            <mbsc-eventcalendar [invalid]="invalid" [extendDefaultEvent]="defaultShift" [view]="diagnoView"
                [options]="diagnoTimelineOptions" [data]="diagnoShifts" [resources]="resource">
            </mbsc-eventcalendar>
            <mbsc-popup [options]="popupOptions" [buttons]="popupButtons" [headerText]="popupHeader" #popup
                class="employee-shifts-popup"></mbsc-popup>
        </div>
        <div class="actions">
        <button type="button" form="diagnoSetAvailabilityForm" id="diagnoSetAvailabilitySubmit"
            class="theme-button grey pointer-disable float-md-right" (click)="saveShift()">Save</button>
            <button type="button"  id="diagnoSetAvailabilityClose" class="theme-button pointer-disable grey float-md-right mr-2" 
            (click)="closeShift()" >Close</button>
         </div>
    </form>
</div>

<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-scale-multiple"></ngx-spinner>